__webpack_require__.p = "/bukhara/";